import {
  type BorderRadiusCorners,
  Box,
  RadioButton,
  Text,
  dimensions,
} from '@factorialco/deprecated-design-system'

import LabeledInput from 'modules/core/components/LabeledInput'

interface Props {
  options: Array<{ value: string; label: string }>
  value: string
  onClick: (value: string) => void
  mandatory: boolean
  readonly: boolean
}

const getBorderRadius = (isFirst: boolean, isLast: boolean): BorderRadiusCorners | undefined => {
  if (isFirst) {
    return {
      topLeft: 'abs008',
      topRight: 'abs008',
    }
  }

  if (isLast) {
    return {
      bottomLeft: 'abs008',
      bottomRight: 'abs008',
    }
  }
}

const Select = ({ options, value, onClick, mandatory, readonly }: Props) => (
  <LabeledInput mandatory={mandatory} value={value} readonly={readonly} isLegend>
    {options.map(({ value: optionValue, label: optionLabel }, index) => {
      const isFirst = index === 0
      const isLast = index === options.length - 1
      const isSelected = value === optionValue

      // NOTE: Hack Alert!
      // Using this hack here since we want to have the selected one on front. Also, since
      // border is adding some extra space, we need to remove it with a negative margin.
      const customStyle = {
        marginTop: isFirst ? 'none' : `-${dimensions.s2}`,
        zIndex: isSelected ? '1' : '0',
      }

      return (
        <label key={optionValue} style={customStyle}>
          <Box
            flexDirection="row"
            gap="s8"
            padding="s16"
            minWidth="full"
            border={{
              all: {
                width: 's2',
                style: 'solid',
                color: isSelected ? 'viridian1000' : 'grey400',
              },
            }}
            borderRadius={getBorderRadius(isFirst, isLast)}
            background={readonly ? 'grey200' : 'grey000White'}
          >
            <RadioButton
              value={optionValue}
              checked={isSelected}
              onChange={() => onClick(optionValue)}
              disabled={readonly}
              size="medium"
            />
            <Text.Normal>{optionLabel}</Text.Normal>
          </Box>
        </label>
      )
    })}
  </LabeledInput>
)

export default Select
